import { runTestBulkOptions } from '../RunTestBulkSelects';

export const filterOptions = (pageType: string) => {
  return runTestBulkOptions.filter((option) => {
    if (pageType === '') {
      return true;
    } else if (
      pageType === 'brokenlink' ||
      pageType === 'Common' ||
      pageType === 'pre-qa' ||
      pageType === 'pd-pre-qa'
    ) {
      const allowedValues = ['content', 'gnb', 'footer'];
      return allowedValues.includes(option.value);
    } else {
      const allowedValues = ['otk', 'checklist'];
      return allowedValues.includes(option.value);
    }
  });
};

export const filterValue = (label: string) => {
  return runTestBulkOptions.filter((option) => {
    if (label === '' || !label) {
      return false;
    } else {
      return label.split('&').includes(option.value);
    }
  });
};
